module.exports = __webpack_public_path__ + "img/no-results.93f81db6.svg";